// Centralised external links — all real Jordan Young URLs.
export const LINKS = {
  // Stan Store
  stanStore: "https://stan.store/jordanyoung",
  ideaToIncome:
    "https://stan.store/jordanyoung/p/get-my-free-idea-to-income-ebook-now",
  businessAudit:
    "https://stan.store/jordanyoung/p/book-a-11-business-audit-with-me",

  // Social
  instagram: "https://www.instagram.com/jayxldn/",
  youtube: "https://www.youtube.com/@Jayxldn",
  email: "mailto:jordanyoung@londonlighting10.com",
  findMyFilmmaker: "", // not provided; mention without link

  // Google Form (still used by the main Builder Programme application section).
  googleFormEmbed: "https://forms.gle/bNADzJiRhqiqBfe2A",

  // Stripe Payment Link for The Builders Sprint (live).
  buildDayCheckout: "https://buy.stripe.com/14A5kD4jk3ic0927dadMI00",
};

// Real media assets supplied by Jordan.
export const ASSETS = {
  heroVideo:
    "https://customer-assets.emergentagent.com/job_the-real-grind/artifacts/gw6scvmy_ScreenRecording_05-23-2026%2023-11-18_1.mov",
  portrait:
    "https://customer-assets.emergentagent.com/job_the-real-grind/artifacts/4fv7vdwl_LLDN5597.JPG",
  speakingVideo:
    "https://customer-assets.emergentagent.com/job_the-real-grind/artifacts/e9tum2dm_21F9B2ED-C11F-47AB-BBE5-F70EAFE6D58F.MP4",
  londonLighting1:
    "https://customer-assets.emergentagent.com/job_the-real-grind/artifacts/fjzkru53_IMG_4846.JPG",
};
